<div class="modal-overlay"></div>
<div class="wrapper">
    @if (showBackButton) {
        <button class="icon icon-arrow-back" (click)="backClicked.emit()"></button>
    }
    <h2 i18n>Select table game</h2>

    <button
        *ngIf="!toggleButtonHidden"
        i18n
        class="button-game button-icon-checkbox button-virtual-toggle"
        [class.button-selected]="virtualSelected"
        (click)="updateFilteredGames(!virtualSelected)"
    >
        Show virtual games
    </button>

    <div
        class="available-games"
        [class.content-columns-1]="(filteredGames.length || 0) === 1"
        [class.content-columns-2]="(filteredGames.length || 0) % 2 === 0"
    >
        @for (game of filteredGames; track game.id) {
            <button
                i18n
                class="button-game button-game-medium"
                [class.button-game-selected]="game.id === currentGameId"
                (click)="gameSelected.emit({ gameId: game.id })"
            >
                {{ game.displayName }}
            </button>
        }
    </div>

    <div *ngIf="unfinishedGame" class="unfinished-game">
        <div i18n class="unfinished-game-title">Unfinished game</div>

        <button i18n class="button-game button-game-medium" (click)="gameSelected.emit({ gameId: unfinishedGame.id, isUnfinished: true })">
            {{ unfinishedGame.displayName }}
        </button>
    </div>
</div>
